import styled from "styled-components";

const PageHeader = styled.h2`
  margin: 40px auto 100px;
  font-size: 2rem;
  font-weight: 900;
  color: ${(p) => (p.theme === "dark" ? "#fff" : "rgb(109, 131, 242)")};
  text-align: center;
  letter-spacing: 1px;
  position: relative;
  z-index: 10;
`;

export default PageHeader;
